const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

function isProduction(): boolean {
  return process.env.NODE_ENV === 'production';
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${name}=`;
  const match = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!match) return null;
  return decodeURIComponent(match.slice(prefix.length));
}

export type SetCookieOptions = {
  maxAgeSeconds?: number;
  /** e.g. `.communiosocial.com` so apex + Free slugs share the cookie. */
  domain?: string;
};

export function setCookie(name: string, value: string, maxAgeSecondsOrOpts: number | SetCookieOptions = ONE_YEAR_SECONDS): void {
  if (typeof document === 'undefined') return;
  const opts: SetCookieOptions =
    typeof maxAgeSecondsOrOpts === 'number'
      ? { maxAgeSeconds: maxAgeSecondsOrOpts }
      : maxAgeSecondsOrOpts;
  const maxAge = opts.maxAgeSeconds ?? ONE_YEAR_SECONDS;
  const secure = isProduction() ? '; Secure' : '';
  const domain = opts.domain ? `; Domain=${opts.domain}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}${domain}`;
}

export function deleteCookie(name: string, domain?: string): void {
  if (typeof document === 'undefined') return;
  const secure = isProduction() ? '; Secure' : '';
  const domainPart = domain ? `; Domain=${domain}` : '';
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${secure}${domainPart}`;
}
